import "core-js/modules/es.array.map.js";
import React from 'react';
import { VideoListItem } from '../VideoListItem';
import { SectionTitle } from '../SectionTitle';
import { Inner } from './partials';
export var VideoList = function VideoList(_ref) {
  var videos = _ref.videos,
    onAction = _ref.onAction;
  return React.createElement(Inner, null, React.createElement(SectionTitle, null, "En modo v\xEDdeo"), React.createElement("div", null, videos.map(function (video, index) {
    return React.createElement(VideoListItem, {
      key: index,
      video: video,
      onAction: onAction
    });
  })));
};